import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { uploadFile, UploadResponse } from '@/api/upload';

export function useUpload() {
  return useMutation<UploadResponse, AxiosError<{ message?: string }>, File>({
    mutationFn: uploadFile,
  });
}
